import { List } from 'immutable';
import { createSelector, defaultMemoize } from 'reselect';

import {
    isResourceComplete,
    isResourceLoading,
    getResourceTotal,
    getResourcePage,
} from './common';

const isFieldManagementNewsLoading = defaultMemoize(isResourceLoading);
const getFieldManagementNewsTotal = getResourceTotal;
const getFieldManagementNewsPage = getResourcePage;
const getFieldManagementNews = defaultMemoize(
    (data) => data.get('fieldManagementNews', List()),
);

const isFeaturedFieldManagementNewsLoading = defaultMemoize(isResourceLoading);
const getFeaturedFieldManagementNews = defaultMemoize(
    (data) => data.get('fieldManagementNews', List()),
);

const getFieldManagementData = (state) => state.getIn(['app', 'fieldManagement']);
const isFieldManagementLoaded = createSelector(getFieldManagementData, isResourceComplete);
const getFieldManagementTitle = createSelector(getFieldManagementData, (data) => data.getIn(['fieldManagement', 'title']));

export {
    isFeaturedFieldManagementNewsLoading,
    isFieldManagementLoaded,
    isFieldManagementNewsLoading,
    getFeaturedFieldManagementNews,
    getFieldManagementNewsTotal,
    getFieldManagementNewsPage,
    getFieldManagementNews,
    getFieldManagementTitle,
};
